import {useImageOverlayMapLayerProvider} from "base/component/geo";

import {createImageOverlayLayerLegend, useImageOverlayLayerObject} from "base/map";
import SquareIcon from "@mui/icons-material/Square";
const layersBounds = [
    [35.059144518, -13.868055734],
    [65.920960866, 28.074501814],
];

export function useMaritimetransportemploymentMapProvider(config) {
    const layer = useImageOverlayLayerObject({
        opacity: 0.5,
        imageUrl: "/images/Maritimetransportemployment.png",
        imageBounds: layersBounds,
        legend: createImageOverlayLayerLegend({
            layerName: "Maritime transport Employment",
            layerType: "rst",
            legendItems: [
                {
                    label: "(FTEs)",
                    color: "white",
                    icon: null,
                },
                {
                    label: "<= 0,0023",
                    color: "#def5e5",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0023 - 0,0075",
                    color: "#62cfac",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0075 - 0,0181",
                    color: "#3498a9",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0181 - 0,0415",
                    color: "#395d9c",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0415 - 0,1175",
                    color: "#382a54",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "> 0,1175",
                    color: "#0b0405",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
            ],
        }),
    });
    const [provider] = useImageOverlayMapLayerProvider(layer, config);

    return provider;
}
